<template>
  <div class="carousel">
    <animation
      v-model="animation"
      :options="animationOptions"
    />

    <div class="tb-form-group">
      <label class="tb-label">Cycle speed</label>

      <input
        type="number"
        class="tb-input"
        :value="getNiceTime(getField('displayTime'))"
        data-entity="producer-editor-displayTime"
        data-test="displays-editor-cycleSpeed"
        @keyup.right.stop
        @keyup.left.stop
        @change="setNiceTime('displayTime', $event.target.value)"
      >

      <span class="help-text">Range: 1 - 100 seconds</span>
    </div>

    <background :item="item" :theme="theme" />

    <div
      v-if="getField('template') === 'lowerthird' || getField('template') === 'sidebar'"
      class="tb-form-group"
      data-entity="producer-editor-toggleKeyColorPicker"
      data-test="displays-editor-keyColorToggle"
    >
      <label class="tb-label">Chroma key color</label>
      <colorpicker :color="getField('keyColor')" v-on:change="setField('keyColor', $event)"></colorpicker>
    </div>

    <!-- QR Code -->
    <p class="tb-label">QR Code</p>
    <div class="tb-checkbox" data-entity="producer-editor-toggleQRCode">
      <input type="checkbox" id="showQrCode" v-model="showQrCode" data-test="displays-editor-showQrCode">
      <label class="checkbox" for="showQrCode">Show</label>
    </div>

    <template v-if="showQrCode">
      <qr-code-url
        :url.sync="permalink"
        :short-url.sync="shortLink"
        :product-info.sync="qrProductInfo"
        :item="item"
        :element="theme"
        :entity-id="theme._id"
      />

      <div class="tb-form-group margin-top-md">
        <label class="tb-label">Background Color</label>

        <colorpicker
          :color="themeFields.qrCodeBackgroundColor"
          data-entity="producer-editor-toggleQRCodeBackgroundColorPicker"
          data-test="displays-editor-qrCodeBackgroundColor"
          @change="setField('qrCodeBackgroundColor', $event)"
        />
      </div>

      <div class="tb-form-group">
        <label class="tb-label">Dot Color</label>

        <colorpicker
          :color="themeFields.qrCodeDotColor"
          data-entity="producer-editor-toggleQRCodeDotColorPicker"
          data-test="displays-editor-qrCodeDotColor"
          @change="setField('qrCodeDotColor', $event)"
        />
      </div>

      <div class="tb-form-group">
        <div class="tb-checkbox">
          <input
            type="checkbox"
            id="showQrCodeLogo"
            v-model="showQrCodeLogo"
            data-entity="producer-editor-toggleImageLogo"
            data-test="displays-editor-qrCode-logo"
            @change="$emit('value', { value: $event.target.checked, field: 'showQrCodeLogo'} )"
          />

          <label class="checkbox" for="showQrCodeLogo">Show image logo</label>
        </div>
      </div>

      <template v-if="showQrCodeLogo">
        <div class="tb-form-group">
          <div v-if="getField('qrCodeLogo')" class="media-upload-wrapper">
            <div class="media" :style="{ 'background-image' : 'url(' + getField('qrCodeLogo') + ')' }"></div>
            <div class="edit-media">
              <button
                class="tb-btn tb-btn-contained on-image"
                data-entity="producer-editor-editLogo"
                data-test="displays-editor-qrCode-selectLogo"
                @click="selectAsset"
              >
                <span class="icon icon-pencil" />
              </button>

              <button
                class="tb-btn tb-btn-contained on-image"
                data-entity="producer-editor-clearBackgroundImage"
                data-test="displays-editor-qrCode-clearLogo"
                @click="setField('qrCodeLogo', '')"
              >
                <span class="icon icon-cross" />
              </button>
            </div>
          </div>

          <button
            v-else
            class="tb-btn tb-btn-contained medium-em"
            data-entity="producer-editor-selectLogo"
            data-test="displays-editor-qrCode-selectLogo"
            @click="selectAsset"
          >
            <span class="icon icon-picture margin-right-xxs"></span>
            Choose image
          </button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

import Background from '../shared/Background.vue';
import Animation from '../shared/Animation.vue';
import QrCodeUrl from '../../shared/QrCodeUrl.vue';

export default {
  mixins: [editingMixins],

  components: {
    Background,
    Animation,
    QrCodeUrl,
  },

  data() {
    return {
      animationOptions: [
        'Slide',
        'Scale',
        'Flow',
      ],
    };
  },

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },

  computed: {
    showQrCode: {
      get() {
        return this.themeFields.showQrCode;
      },

      set(v) {
        this.setField('showQrCode', v);
      },
    },

    showQrCodeLogo: {
      get() {
        return this.themeFields.showQrCodeLogo;
      },

      set(v) {
        this.setField('showQrCodeLogo', v);
      },
    },

    qrCodeLogo: {
      get() {
        return this.themeFields.qrCodeLogo;
      },

      set(v) {
        this.setField('qrCodeLogo', v);
      },
    },

    permalink: {
      get() {
        return this.themeFields.permalink;
      },

      set(v) {
        this.setField('permalink', v);
      },
    },

    shortLink: {
      get() {
        return this.themeFields.shortLink ?? '';
      },
      set(v) {
        this.setField('shortLink', v);
      },
    },

    qrProductInfo: {
      get() {
        return this.themeFields.qrProductInfo ?? {};
      },
      set(v) {
        this.setField('qrProductInfo', v);
      },
    },
  },

  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset) => {
        this.setField('qrCodeLogo', asset.media_url);
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },
};
</script>
